// import MiniHeader from "@/components/Inventory/MiniHeader";
import AgTable from "../../component/Ag-Table/AgTable";
import {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
  useRef,
} from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCategory,
  getAllInventory,
  getAllVendor,
  deleteInventoryBYid,
  defaultpartUpdatebyid,
} from "../../api/inVentory";
import axios from "axios";
// import { baseUrl } from "../../config/api-config";
// import basket from "../../../public/assets/images/basket.png";
// import ImageDialog from "./image-dialog";
import Select from "react-select";
// import MoveModal from "../../component/Inventory/Modal/MoveItems";
import {
  UpdateIsActiveStatusByID,
  UpdateStatusByID,
  getAllManufacturers,
} from "../../api/Manufacturers";
// import { Allmanufactures, Allvendors } from "@/redux/Slices/inventory";
// import { useRouter } from "next/router";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { baseUrl } from "../../config/api-config";
let array = [] ;
let arrayCategory = [] ;

let optionsArray = [] ;
const axiosInstance = axios.create({
  baseURL: baseUrl,
});
export default function Inventory() {
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  const user = useSelector((state) => state.user);
  const [tab, setTab] = useState("stock_item");
  const [refresh, setRefresh] = useState(false);
  const [paramsData, setParamsData] = useState({});
  const [isUploadImage, setIsUploadImage] = useState(false);
  const [deleteLoad, setDeleteLoad] = useState("");
  const [gridApi, setGridApi] = useState(null) ;
  const [editableRowIndex, setEditableRowIndex] = useState(null);
  const [moveModal, setMoveModal] = useState({
    isModal: false,
    id: "",
  });
  console.log(user, "user in inventory");
  // const router = useRouter();
  const [moveItem_thenRefresh, setMovethenRefresh] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [filterValues, setFilterValues] = useState() ;
  const [filterPlaceholders, setFilterPlaceholders] = useState({});

  const filterOptions = [
    { value: "itemDescription", label: "Item Description" },
    { value: "internalSku", label: "Internal SKU" },
    { value: "category", label: "Category", type: "select" },
    { value: "vendor", label: "Vendor", type: "select" }, // Added type field
    { value: "manufacturer", label: "Manufacturer", type: "select" }, // Added type field
  ];
  const [vendorFilter, setVendorFilter] = useState("");
  const [manufacturerFilter, setManufacturerFilter] = useState(
    ""
  );
  const [categoryFilter, setCategoryFilter] = useState("");
  const [internalFilter, setInternalFilter] = useState("");
  const [itemFilter, setItemFilter] = useState("");
  const [selectedItemsTomoveToNonStock, setselectedItemsTomoveToNonStock] =
    useState([]);

  const [vendorOptions, setVendorOptions] = useState() ;
  const [manufacturerOptions, setManufacturerOptions] = useState([
    ...optionsArray,
  ]) ;
  const [categoryOptions, setCategoryOptions] = useState() ;
  const [onSaveLoading, setOnsaveLoading] = useState("") ;
  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }

  useEffect(() => {
    refreshTable();
  }, [
    tab,
    filterValues,
    itemFilter,
    internalFilter,
    vendorFilter,
    manufacturerFilter,
    categoryFilter,
    selectedFilters,
    moveItem_thenRefresh,
  ]);
  useEffect(() => {
    setselectedItemsTomoveToNonStock([]);
  }, [tab]);
  const handleCheckboxChange = (rowData) => {
    rowData.checked = !rowData.checked;
    if (rowData.checked) {
      setselectedItemsTomoveToNonStock((prevArray) => [
        ...prevArray,
        rowData,
      ]);
    } else {
      setselectedItemsTomoveToNonStock((prevArray) =>
        prevArray.filter((row) => row.id !== rowData.id)
      );
    }
  };
  const columnDef = [
    // {
    //   headerName: "",
    //   field: "id",
    //   sortable: true,
    //   resizable: true,

    //   cellRenderer: (params) => (
    //     <>
    //       {/* {user.role === "Admin" ? (
    //         <div className="flex  gap-3 checkbox-animate">
    //           <label>
    //             <input
    //               name="check"
    //               type="checkbox"
    //               className="cursor-pointer"
    //               defaultChecked={selectedItemsTomoveToNonStock.some(
    //                 (row) => row?.id === params?.data?.id
    //               )}
    //               onChange={() => handleCheckboxChange(params.data)}
    //             />
    //             <span className="input-check"></span>
    //           </label>
    //         </div>
    //       ) : null} */}
    //     </>
    //   ),
    //   wrapText: true,
    //   minWidth: 50,
    //   maxWidth: 80,
    //   cellStyle: { alignItems: "center", display: "flex" },
    // },
    // {
    //   headerName: "Action",
    //   field: "id",
    //   headerClass: "header-center",
    //   cellStyle: { alignItems: "center", display: "flex" },
    //   cellRenderer: (params) => (
    //     <>
    //       {user.role === "Admin" ? (
    //         <div className="flex  w-full gap-7 justify-center">
    //           {/* <Link
    //             href={`/inventory-list/inventory-info/${params?.data?.id}`}
    //             className="cursor-pointer py-1 text-[#fff] to-[#145df1] capitalize h-[40px] w-[40px] p-[5px] text-sm font-normal rounded-[5px] flex items-center justify-center hover:bg-[#002D62] hover:text-[#fff]"
    //             title="Edit"
    //           >
    //             <svg
    //               className="w-6 h-6 text-gray-800 cursor-pointer"
    //               aria-hidden="true"
    //               xmlns="http://www.w3.org/2000/svg"
    //               width="24"
    //               height="24"
    //               fill="currentColor"
    //               viewBox="0 0 24 24"
    //             >
    //               <path
    //                 fillRule="evenodd"
    //                 d="M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z"
    //                 clipRule="evenodd"
    //               />
    //               <path
    //                 fillRule="evenodd"
    //                 d="M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z"
    //                 clipRule="evenodd"
    //               />
    //             </svg>
    //           </Link> */}
    //           {editableRowIndex === params.node.rowIndex ? (
    //             <div className="flex  gap-2">
    //               <button
    //                 // className="bg-[#3f63ea] py-1 text-[#fff] to-[#145df1] capitalize h-[30px] p-[5px] text-sm font-normal rounded-[5px] w-[80px] flex items-center justify-center hover:bg-[#002D62] hover:text-[#fff]"
    //                 onClick={() => handleEditClick(params)}
    //               >
    //                 <img title="cancel-edit" 
    //                   width="25"
    //                   height="25"
    //                   src="https://img.icons8.com/color/48/cancel--v1.png"
    //                   alt="cancel--v1"
    //                 />
    //               </button>
    //               <button
    //                 // className="bg-[#3f63ea] py-1 text-[#fff] to-[#145df1] capitalize h-[30px] p-[5px] text-sm font-normal rounded-[5px] w-[80px] flex items-center justify-center hover:bg-[#002D62] hover:text-[#fff]"
    //                 onClick={() => onRowSave(params)}
    //                 disabled={onSaveLoading}
    //               >
    //                 {onSaveLoading ? (
    //                   <span className="delete-loader"></span>
    //                 ) : (
    //                   <img
    //                   title="save-changes"
    //                     width="25"
    //                     height="25"
    //                     src="https://img.icons8.com/fluency/50/save.png"
    //                     alt="save"
    //                   />
    //                 )}
    //               </button>
    //             </div>
    //           ) : (
    //             <div className="flex  gap-2">
    //               <button
    //                  title="edit-row"  
    //                 // className="bg-[#3f63ea] py-1 text-[#fff] to-[#145df1] capitalize h-[30px] p-[5px] text-sm font-normal rounded-[5px] w-[80px] flex items-center justify-center hover:bg-[#002D62] hover:text-[#fff]"
    //                 onClick={() => handleEditClick(params)}
    //               >
    //                 <svg
    //               className="w-6 h-6 text-gray-800"
    //                   aria-hidden="true"
    //                   xmlns="http://www.w3.org/2000/svg"
    //                   width="24"
    //                   height="24"
    //                   fill="currentColor"
    //                   viewBox="0 0 24 24"
    //                 >
    //                   <path
    //                     fillRule="evenodd"
    //                     d="M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z"
    //                     clipRule="evenodd"
    //                   />
    //                   <path
    //                     fillRule="evenodd"
    //                     d="M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z"
    //                     clipRule="evenodd"
    //                   />
    //                 </svg>
    //               </button>
    //             </div>
    //           )}
    //           {params?.data?.id === deleteLoad ? (
    //             <span className="delete-loader"></span>
    //           ) : (
    //             <button
    //               onClick={() =>
    //                 handleDelete(
    //                   params?.data?.id,
    //                   user.token,
    //                   refreshTable,
    //                   setDeleteLoad
    //                 )
    //               }
    //               // className="bg-[#3f63ea] py-1 text-[#fff] to-[#145df1] capitalize h-[30px] p-[5px] text-sm font-normal rounded-[5px] w-[80px] flex items-center justify-center hover:bg-[#002D62] hover:text-[#fff]"
    //               title="delete"
    //             >
    //               <img
    //                 width="28"
    //                 height="28"
    //                 src="https://img.icons8.com/plasticine/100/filled-trash.png"
    //                 alt="filled-trash"
    //               />
    //             </button>
    //           )}
    //         </div>
    //       ) : (
    //         ""
    //       )}
    //     </>
    //   ),
    //   resizable: true,
    //   wrapText: true,
    //   minWidth: 120,
    //   maxWidth: 350,
    // },
    // {
    //   headerName: "Image",
    //   field: "imagePath",
    //   resizable: true,
    //   headerClass: "header-center",
    //   headerComponent: ({ displayName, column, api }) => (
    //     <div className="flex  items-center justify-center gap-1 text-[#fff] font-normal ml-1">
    //       <img
    //         width="20"
    //         height="20"
    //         src="https://img.icons8.com/external-vectorslab-flat-vectorslab/53/external-Images-nature-and-travel-vectorslab-flat-vectorslab.png"
    //         alt="external-Images-nature-and-travel-vectorslab-flat-vectorslab"
    //       />
    //       {displayName}
    //     </div>
    //   ),

    //   cellStyle: {
    //     alignItems: "center",
    //     display: "flex",
    //     justifyContent: "center",
    //   },
    //   cellRenderer: (params) => (
    //     <>
    //       <div
    //         onClick={() => {
    //           setParamsData(params);
    //           setIsUploadImage(true);
    //         }}
    //         className="flex gap-3 text-[12px] cursor-pointer"
    //       >
    //         {params?.data?.imagePath?.includes("null") ||
    //         !params?.data?.imagePath?.includes(".") ? (
    //           <img
    //             src="https://static.vecteezy.com/system/resources/previews/022/059/000/non_2x/no-image-available-icon-vector.jpg"
    //             alt="no-image"
    //             className="h-[105] w-[115px] border-[2px] border-[#5454544a] rounded-[10px] p-[2px]"
    //           />
    //         ) : (
    //           <img
    //             src={baseUrl + params?.data?.imagePath.replace("/api", "")}
    //             className="h-[105px] w-[115px] border-[2px] border-[#5454544a] rounded-[10px] p-[2px]"
    //           />
    //         )}
    //       </div>
    //     </>
    //   ),
    //   wrapText: true,
    //   minWidth: 100,
    //   maxWidth: 170,
    // },
    // {
    //   headerName: "View an Inventory",
    //   field: "inventory_name",
    //   cellStyle: { alignItems: "center", display: "flex" },
    //   cellRenderer: (params) => (
    //     <>
    //       <div className="flex  gap-3">
    //         <Link
    //           to={`/inventory-list/inventory-info/${params?.data?.id}`}
    //           className="cursor-pointer py-1 text-[#fff] to-[#145df1] capitalize h-[40px] w-[40px] p-[5px] text-sm font-normal rounded-[5px] flex items-center justify-center hover:bg-[#002D62] hover:text-[#fff]"
    //         >
    //           <span className="text-blue-800 flex gap-2 font-semibold cursor-pointer items-center">
    //             {/* <img src={basket} className="h-[20px] w-[20px]" />{" "} */}
    //             {params?.data?.inventory_name}
    //           </span>
    //         </Link>
    //       </div>
    //     </>
    //   ),
    //   resizable: true,
    //   wrapText: true,
    //   editable: (params) => editableRowIndex === params.node.rowIndex,

    //   autoHeight: true,
    //   minWidth: 130,
    //   maxWidth: 350,
    // },
    {
      headerName: "Item Description",
      field: "item_description",
      resizable: true,
      wrapText: true,
      editable: (params) => editableRowIndex === params.node.rowIndex,

      autoHeight: true,
      minWidth: 350,
      maxWidth: 390,
    },
    {
      headerName: "Finish",
      field: "finish",
      resizable: true,

      wrapText: true,
      editable: (params) => editableRowIndex === params.node.rowIndex,

      autoHeight: true,
      minWidth: 70,
      maxWidth: 350,
    },
    {
      headerName: "Color",
      field: "color",
      resizable: true,
      wrapText: true,
      editable: (params) => editableRowIndex === params.node.rowIndex,

      autoHeight: true,
      headerComponent: ({ displayName, column, api }) => (
        <div className="flex  items-center gap-1 text-[#000] font-normal">
          <img
            width="20"
            height="20"
            src="https://img.icons8.com/fluency/48/color-mode--v1.png"
            alt="color-mode--v1"
          />{" "}
          {displayName}
        </div>
      ),
      minWidth: 80,
      maxWidth: 150,
    },
    {
      headerName: "Dimensions",
      field: "dimensions",
      resizable: true,

      headerComponent: ({ displayName, column, api }) => (
        <div className="flex  items-center gap-1 text-[#000] font-normal">
          <img
            width="20"
            height="20"
            src="https://img.icons8.com/external-flaticons-lineal-color-flat-icons/64/external-dimension-logistics-flaticons-lineal-color-flat-icons.png"
            alt="external-dimension-logistics-flaticons-lineal-color-flat-icons"
          />{" "}
          {displayName}
        </div>
      ),
      autoHeight: true,
      wrapText: true,
      editable: (params) => editableRowIndex === params.node.rowIndex,

      minWidth: 120,
      maxWidth: 350,
    },
    {
      headerName: "Internal SKU",
      field: "internal_sku",
      resizable: true,
      wrapText: true,
      editable: (params) => editableRowIndex === params.node.rowIndex,

      autoHeight: true,
      minWidth: 95,
      maxWidth: 350,
    },
    {
      headerName: "Vendor(s)",
      field: "vendor_id",
      resizable: true,
      wrapText: true,
      editable: (params) => editableRowIndex === params.node.rowIndex,

      autoHeight: true,
      cellEditor: "textAreaEditor",
      cellRenderer: (params) => (
        <>
          {" "}
          <div
            style={{
              whiteSpace: "normal",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {params?.data?.vendor_name}
            {/* {array
              ?.map((option) =>
                Number(params.data?.vendor_name)
                  ? option?.value?.toString() ===
                    params?.data?.vendor_name?.toString()
                    ? option.label
                    : ""
                  : params.data?.vendor_name
              )
              ?.find((label) => label !== "")} */}
          </div>
        </>
      ),
      minWidth: 80,
      maxWidth: 250,
    },
    {
      headerName: "UoM",
      field: "uom",
      resizable: true,
      wrapText: true,
      editable: (params) => editableRowIndex === params.node.rowIndex,

      minWidth: 80,
      maxWidth: 140,
    },
    {
      headerName: "Category",
      field: "category",
      resizable: true,
      wrapText: true,
      editable: (params) => editableRowIndex === params.node.rowIndex,

      cellEditor: "textSelectEditor",
      cellRenderer: (params) => (
        <>
          {" "}
          <div
            style={{
              whiteSpace: "normal",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {params.data?.category_name}
            {/* {arrayCategory
              ?.map((option) =>
                Number(params.data?.category_name)
                  ? option?.value?.toString() ===
                    params?.data?.category_name?.toString()
                    ? option.label
                    : ""
                  : params.data?.category_name
              )
              ?.find((label) => label !== "")} */}
          </div>
        </>
      ),

      minWidth: 80,
      maxWidth: 350,
    },
    // {
    //   headerName: "Default Part",
    //   field: "is_default_part",
    //   resizable: true,
    //   wrapText: true,
    //   //  editable: (params) => editableRowIndex === params.node.rowIndex,

    //   cellRenderer: (params) => (
    //     <>
    //       {" "}
    //       {user.role === "admin" ? (
    //         <div
    //           style={{
    //             whiteSpace: "normal",
    //             overflow: "hidden",
    //             textOverflow: "ellipsis",
    //           }}
    //           className="flex gap-3 checkbox-animate"
    //         >
    //           <label>
    //             <input
    //               name="check"
    //               onChange={(event) =>
    //                 onChangeDefaultCheck(event.target.checked, params?.data?.id)
    //               }
    //               type="checkbox"
    //               defaultChecked={params?.data?.is_default_part === "t"}
    //             />
    //             <span className="input-check"></span>
    //           </label>
    //         </div>
    //       ) : null}
    //       {/* <div
          
    //       >
    //         <input
    //           onChange={(event) =>
    //             onChangeDefaultCheck(event.target.checked, params?.data?.id)
    //           }
    //           type="checkbox"
    //           defaultChecked={params?.data?.is_default_part === "t"}
    //         />
    //       </div> */}
    //     </>
    //   ),
    //   minWidth: 100,
    //   maxWidth: 350,
    // },
    {
      headerName: "Manufacturer",
      field: "manufacturer",
      resizable: true,
      cellRenderer: (params) => (
        <>
          <p className="text-[#000]">{params?.data?.manufacture_name}</p>
        </>
      ),

      cellEditor: "textManufactureEditor",
      wrapText: true,
      editable: (params) => editableRowIndex === params.node.rowIndex,

      minWidth: 100,
      maxWidth: 350,
    },
    // {
    //   headerName: "Is Active",
    //   field: "is_active",
    //   resizable: true,
    //   cellRenderer: (params) => (
    //     <>
    //       <div className="flex  justify-center items-center gap-3">
    //        {params?.data?.is_active === "t" ? "Active" : "In-Active"}
    //       </div>
    //     </>
    //   ),
    //   cellEditor: "textManufactureEditor",
    //   wrapText: true,
    //   minWidth: 100,
    //   maxWidth: 350,
    // },
    //     {
    //       headerName: "Action",
    //       field: "inventory_name",
    //       headerClass: "header-center",
    //       cellStyle: { alignItems: "center", display: "flex" },
    //       cellRenderer: (params) => (
    //         <>
    //           <div className="grid gap-2">
    //            {onSaveLoading === params?.data?.id ?  <div role="status" className="flex justify-center">
    //     <svg aria-hidden="true" className="inline w-9 h-9 text-gray-200 animate-spin dark:text-gray-600 fill-lime-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
    //         <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
    //         <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
    //     </svg>
    //     <span className="sr-only">Loading...</span>
    // </div>  : <button
    //               onClick={() => onRowSave(params)}
    //               className="bg-[#3f63ea] py-1 text-[#fff] to-[#145df1] capitalize h-[30px] p-[5px] text-sm font-normal rounded-[5px] w-[80px] flex items-center justify-center hover:bg-[#002D62] hover:text-[#fff]"
    //               title="Save Changes"
    //             >
    //              <span className="material-icons">Save</span>
    //             </button>}
    //             {/* {tab === "non_stock_item" && (
    //               <button
    //                 onClick={() =>
    //                   setMoveModal({ id: params?.data?.id, isModal: true })
    //                 }
    //                 className="bg-[#000000] py-1 text-[#fff] to-[#145df1] capitalize h-[30px] p-[5px] text-sm font-normal rounded-[5px] w-[80px] flex items-center justify-center hover:bg-[#161717] hover:text-[#fff]"
    //                 title="Move item"
    //               >
    //                 <span className="material-icons">Move Item</span>
    //               </button>
    //             )} */}

    //             {/* <button
    //             onClick={() =>
    //               JobDeletebyID(params?.data?.id, user.token, setRefresh)
    //             }
    //             className="bg-transparent text-[14px] text-center px-[5px] rounded-[7px] py-[5px]"
    //           >
    //             <svg
    //               xmlns="http://www.w3.org/2000/svg"
    //               fill="none"
    //               viewBox="0 0 24 24"
    //               strokeWidth="1.5"
    //               stroke="currentColor"
    //               className="w-[28px] h-[20px] text-[#00000085]"
    //             >
    //               <path
    //                 strokeLinecap="round"
    //                 strokeLinejoin="round"
    //                 d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    //               />
    //             </svg>
    //           </button> */}
    //           </div>
    //         </>
    //       ),
    //       resizable: true,
    //       wrapText: true,
    //       minWidth: 120,
    //       maxWidth: 350,
    //     },
  ];

  useEffect(() => {
    fetchAllManufacturer("", "");
  }, []);

  const dispatch = useDispatch();
  const fetchAllManufacturer = async (limit, offset) => {
    try {
      const { data } = await getAllManufacturers(user.token, {
        limit: "",
        offset: "",
      });
      if (data.status) {
        data?.data?.map((el) => {
          optionsArray.push({ value: el.id, label: el.manufacture_name });
        });
        // dispatch<any>(Allmanufactures(optionsArray));
      }
    } catch (error) {
      return { error: true };
    }
  };
  const onChangeDefaultCheck = async (check, id) => {
    try {
      const { data } = await defaultpartUpdatebyid(
        user.token,
        { is_default_part: check === true ? "t" : "f" },
        id
      );
      toast.success(data?.msg);
      // setRefresh(true);
      refreshTable();
    } catch (error) {
      console.log(error.message);
    }
  };
  useEffect(() => {
    fetchAllVendors();
    fetchAllCategory();
  }, []);
  const fetchAllVendors = async () => {
    try {
      const { data } = await getAllVendor(user.token, {
        limit: "",
        offset: "",
      });
      if (data.status) {
        array = data.data?.Vendor?.map((el) => {
          return { value: el.id, label: el.vendor_name };
        });
      }
      // dispatch<any>(Allvendors(array));
      setVendorOptions(array);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchAllCategory = async () => {
    try {
      const { data } = await getAllCategory(user.token, {
        limit: "",
        offset: "",
      });
      if (data.status) {
        arrayCategory = data.data?.map((el) => {
          return { value: el.id, label: el.category_name };
        });
      }
      setCategoryOptions(arrayCategory);
      // setManufacturerOptions(optionsArray);
    } catch (error) {
      console.log(error);
    }
  };
  const handleNullValue = (value) => {
    if (value === null || value === "null" || value === undefined) {
      return "";
    }
    return value;
  };

  const onRowSave = async (params) => {
    gridApi.stopEditing();
    setOnsaveLoading(params?.data?.id);
    let formdata = new FormData();
    formdata.append("vendor_id", handleNullValue(params.data.vendor_id));
    // formdata.append("inventory_pic",params.data.inventory_pic);
    formdata.append(
      "inventory_name",
      handleNullValue(params.data.inventory_name)
    );
    formdata.append("internal_sku", handleNullValue(params.data.internal_sku));
    formdata.append(
      "item_description",
      handleNullValue(params.data.item_description)
    );
    formdata.append("uom", handleNullValue(params.data.uom));
    formdata.append(
      "unit_price",
      parseFloat(params.data.unit_price || "0") 
    );
    formdata.append(
      "cost",
      parseFloat(params.data.cost?.toString() || "0") 
    );
    formdata.append(
      "customer_price",
      parseFloat(params.data.customer_price?.toString() || "0") 
    );
    formdata.append("finish", handleNullValue(params.data.finish));
    formdata.append("color", handleNullValue(params.data.color));
    formdata.append("dimensions", handleNullValue(params.data.dimensions));
    formdata.append(
      "special_description",
      handleNullValue(params.data.special_description) || "  "
    ); // Optional default value for empty descriptions
    formdata.append("manufacturer", handleNullValue(params.data.manufacturer));
    formdata.append("category", handleNullValue(params.data.category));
    formdata.append("is_default_part", params.data.is_default_part);
    formdata.append("status", handleNullValue(params.data?.status));
    formdata.append("markupvalue", handleNullValue(params.data.markupvalue));
    formdata.append("discount", handleNullValue(params.data.discount));
    axiosInstance
      .patch(`/updateInventoryById/${params?.data?.id}`, formdata, {
        headers: {
          Authorization: `${user.token}`,
        },
      })
      .then((res) => {
        toast.success("Inventory Updated..!");
        refreshTable();
        setOnsaveLoading("");
      })
      .catch((error) => {
        console.log(error?.message);
        setOnsaveLoading("");
        toast.error(error?.response?.data?.error || "Network Error..!");
      });
  };
  const fetchAllInvetory = async (limit, offset) => {
    try {
      const { data } = await getAllInventory(user.token, {
        limit: limit,
        offset: offset,
        status: tab === "inactive_items" ? "" : tab,
        vendorname: vendorFilter || "",
        manufacturer: manufacturerFilter || "",
        category: categoryFilter || "",
        internalSku: internalFilter || "",
        itemDescription: itemFilter || "",
        is_active: tab === "inactive_items" ? "f" : "t",
      });
      // setRefresh(false);
      setMovethenRefresh(false);
      return {
        rows: data.data.Inventory,
        total: parseInt(data.data.total),
        error: false,
      };
    } catch (error) {
      console.log(error?.message);
      setMovethenRefresh(false);
      // setRefresh(false);
      return { error: true };
    }
  };
  const handleFilterChange = (selectedOptions) => {
    setSelectedFilters(
      selectedOptions ? selectedOptions.map((option) => option.value) : []
    );
    setVendorFilter("");
    setManufacturerFilter("");
    setCategoryFilter("");
  };

  const handleInputChange = (
    e,
    filter
  ) => {
    const filterOption = filterOptions.find(
      (option) => option.value === filter
    );
    const placeholder = filterOption ? `Enter ${filterOption.label}` : "";

    // Get the input value
    const inputValue = e.target.value.trim();

    // Update the filter values
    setFilterValues({ ...filterValues, [filter]: inputValue });

    // If the input value is empty, restore the placeholder
    if (inputValue === "") {
      setFilterPlaceholders({ ...filterPlaceholders, [filter]: placeholder });
    }
  };
  const reset = () => {
    setVendorFilter("");
    setFilterValues();
    setItemFilter("");
    setInternalFilter("");
    setManufacturerFilter("");
    setCategoryFilter("");
    setSelectedFilters([]);
  };
  const [isLoading, setIsLoading] = useState(false) ;
  const moveToNonStock = async (name) => {
    if (selectedItemsTomoveToNonStock.length === 0) {
      toast.error("please select any items..!");
      return;
    }
    let datA = [] ;
    selectedItemsTomoveToNonStock.map((el) => {
      if (el.id) {
        datA.push({ id: el.id });
      }
    });
    setIsLoading(true);
    try {
      const { data: res } = await UpdateStatusByID(user.token, {
        inventories: datA,
        status: name,
      });
      toast.success(res.message);
      setMovethenRefresh(true);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast.error(error?.response?.data?.error || error.message);
    }
  };
  const moveToActive_InActive = async (name) => {
    if (selectedItemsTomoveToNonStock.length === 0) {
      toast.error("please select any items..!");
      return;
    }
    let datA = [] ;
    selectedItemsTomoveToNonStock.map((el) => {
      if (el.id && el.is_active === "t") {
        datA.push({ id: el.id, is_active: "f" });
      }
      if (el.id && el.is_active === "f") {
        datA.push({ id: el.id, is_active: "t" });
      }
    });
    setIsLoading(true);
    try {
      const { data: res } = await UpdateIsActiveStatusByID(user.token, {
        inventories: datA,
      });
      toast.success(res.message);
      setMovethenRefresh(true);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast.error(error?.response?.data?.error || error.message);
    }
  };

  const handleEditClick = (params) => {
    const rowIndex = params.node.rowIndex;

    if (editableRowIndex === rowIndex) {
      // Save or end editing
      gridApi.stopEditing();
      setEditableRowIndex(null);
    } else {
      setEditableRowIndex(rowIndex);

      // Programmatically start editing each editable cell
      params.columnApi.getAllColumns().forEach((col) => {
        const colId = col.getColId();
        const colDef = col.getColDef();
        if (colDef.editable) {
          setTimeout(() => {
            gridApi.startEditingCell({
              rowIndex,
              colKey: colId,
            });
          }, 0);
        }
      });
    }
  };
  return (
    <>
        <div style={{ zoom: "0.9" }} className="w-full grid grid-cols-2 mt-4 screen-zoom">
  <div className="col-span-2 mb-4">
    <div className="flex flex-col md:flex-row justify-between items-start gap-4">
      <div className="flex flex-wrap rounded-[10px] overflow-hidden border border-gray-300">
        {[
          { key: "stock_item", label: "Stock Items" },
          { key: "non_stock_item", label: "Non-stock Items" },
          { key: "archived_items", label: "Archived Items" },
          { key: "inactive_items", label: "In-active Items" },
        ].map(({ key, label }, index, arr) => (
          <button
            key={key}
            onClick={() => setTab(key)}
            className={`px-4 py-2 text-sm font-medium transition-all ${
              tab === key
                ? "bg-[#3750b5] text-white"
                : "bg-white text-black hover:bg-gray-100"
            } ${index === 0 ? "rounded-tl-[10px]" : ""} ${
              index === arr.length - 1 ? "rounded-tr-[10px]" : ""
            }`}
          >
            {label}
          </button>
        ))}
      </div>
 
      {user.role === "admin" && (
        <div className="flex flex-wrap gap-2">
          {tab !== "inactive_items" && (
            <button
              disabled={isLoading}
              onClick={() => moveToActive_InActive("")}
              className="flex items-center gap-2 bg-[#00205c] hover:bg-black text-white px-4 py-2 rounded-md transition"
            >
              {isLoading ? (
                "Please wait..!"
              ) : (
                <>
                  <img
                    width="20"
                    src="https://img.icons8.com/stencil/32/resize-four-directions.png"
                    alt="move"
                  />
                  Move to In-Active
                </>
              )}
            </button>
          )}
 
          {[
            ["stock_item", "Move to Stock Items"],
            ["non_stock_item", "Move to Non-stock Items"],
            ["archived_items", "Move to Archived Items"],
          ]
            .filter(([key]) => key !== tab)
            .map(([targetTab, label]) => (
              <button
                key={targetTab}
                disabled={isLoading}
                onClick={() => moveToNonStock(targetTab)}
                className="flex items-center gap-2 bg-[#00205c] hover:bg-black text-white px-4 py-2 rounded-md transition"
              >
                {isLoading ? (
                  "Please wait..!"
                ) : (
                  <>
                    <img
                      width="20"
                      src="https://img.icons8.com/stencil/32/resize-four-directions.png"
                      alt="move"
                    />
                    {label}
                  </>
                )}
              </button>
            ))}
        </div>
      )}
    </div>
  </div>
 
  <div className="col-span-2 bg-white rounded-[10px] p-4 mb-4">
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-4">
      <div className="lg:col-span-2">
        <label className="text-sm font-medium text-gray-700">Filter by Manufacturer</label>
        <Select
          options={optionsArray}
          value={optionsArray.find((option) => option.value === manufacturerFilter) || ""}
          onChange={(option) => setManufacturerFilter(option ? option.label : null)}
          placeholder="Select Manufacturer"
        />
      </div>
 
      <div className="lg:col-span-2">
        <label className="text-sm font-medium text-gray-700">Filter by Internal SKU</label>
        <input
          type="text"
          value={internalFilter || ""}
          onChange={(e) => setInternalFilter(e.target.value)}
          placeholder="Enter SKU"
          className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
 
      <div className="lg:col-span-2">
        <label className="text-sm font-medium text-gray-700">Filter by Item Description</label>
        <input
          type="text"
          value={itemFilter || ""}
          onChange={(e) => setItemFilter(e.target.value)}
          placeholder="Enter Description"
          className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
 
      {(vendorFilter || manufacturerFilter || categoryFilter || itemFilter || internalFilter) && (
        <div className="lg:col-span-2 flex items-end">
          <button
            onClick={reset}
            className="flex items-center gap-2 bg-black text-white px-4 py-2 rounded-md text-sm hover:bg-gray-800"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M16.023 9.348h4.992M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182"
              />
            </svg>
            RESET
          </button>
        </div>
      )}
    </div>
  </div>
 
  <div className="col-span-2 ag-theme-material">
    <AgTable
      getTableRows={fetchAllInvetory}
      columns={user.role === "admin" ? columnDef : columnDef.splice(2, 13)}
      perPage={10}
      refresh={tableRefreshCount}
      setRefresh={""}
      classN={""}
      setGridData={""}
      gridOptions={{ rowModelType: "clientSide" }}
      setGridApi={setGridApi}
      gridApi={gridApi}
      components={{
        textAreaEditor: TextAreaEditor,
        textSelectEditor: TextSelectEditor,
        textManufactureEditor: TextManufactureEditor,
      }}
    />
  </div>
</div>
      {isUploadImage && (
        ""
        // <ImageDialog
        //   setUploadFilesPopup={setIsUploadImage}
        //   getTableRows={refreshTable}
        //   newFile=""
        //   paramsData={paramsData}
        // />
      )}
      {moveModal.isModal && (
        ""
        // <MoveModal
        //   setMovethenRefresh={setMovethenRefresh}
        //   moveModal={moveModal}
        //   setMoveModal={setMoveModal}
        // />
      )}
    </>
  );
}

const TextSelectEditor = forwardRef((props, ref) => {
  const [value, setValue] = useState(props.value);
  const [selectValue, setSelectValue] = useState(props.value) ;
  const textareaRef = useRef(null) ;
  const [categoryOption, setManufacturerOptions] = useState([
    ...arrayCategory,
  ]) ;

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  useImperativeHandle(ref, () => ({
    getValue: () => value,
  }));

  const handleTextareaChange = (event) => {
    setValue(event.target.value);
    setSelectValue(event.target.value);
  };

  const handleTextareaBlur = () => {
    props.stopEditing();
  };

  useEffect(() => {
    textareaRef?.current?.focus();
  }, []);

  return (
    <select
      value={selectValue}
      className="w-[100%] !h-[100%] border-[1px] border-[#000] "
      onBlur={handleTextareaBlur}
      onChange={handleTextareaChange}
    >
      <option value="">Select</option>
      {categoryOption?.map((option, i) => (
        <option value={option.value} key={i}>
          {option.label}
        </option>
      ))}
    </select>
  );
}) ;
const TextAreaEditor = forwardRef((props, ref) => {
  const [value, setValue] = useState(props.value);
  const [selectValue, setSelectValue] = useState(props.value) ;
  const textareaRef = useRef(null) ;
  const [vendorOption, setVendorOptions] = useState([...array]) ;

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  useImperativeHandle(ref, () => ({
    getValue: () => value,
  }));

  const handleTextareaChange = (event) => {
    setValue(event.target.value);
    setSelectValue(event.target.value);
  };

  const handleTextareaBlur = () => {
    props.stopEditing();
  };

  useEffect(() => {
    textareaRef?.current?.focus();
  }, []);

  return (
    <select
      value={selectValue}
      className="w-[100%] h-[100%] border-[1px] border-[#000] "
      onBlur={handleTextareaBlur}
      onChange={handleTextareaChange}
    >
      <option value="">Select</option>
      {vendorOption?.map((option, i) => (
        <option value={option.value} key={i}>
          {option.label}
        </option>
      ))}
    </select>
  );
}) ;
// Forward Refarray

const TextManufactureEditor = forwardRef((props, ref) => {
  const [value, setValue] = useState(props.value);
  const [selectValue, setSelectValue] = useState(
    props.data.manufacturer
  ) ;
  const { manuf: options } = useSelector((state) => state?.inventory);
  const textareaRef = useRef(null) ;
  const [categoryOption, setManufacturerOptions] = useState([
    ...optionsArray,
  ]) ;
  console.log(props.rowIndex, ref, "props ,dkskd");
  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  useImperativeHandle(ref, () => ({
    getValue: () => value,
  }));

  const handleTextareaChange = (event) => {
    setValue(event.target.value);
    setSelectValue(event.target.value);
  };

  const handleTextareaBlur = () => {
    props.stopEditing();
  };

  useEffect(() => {
    textareaRef?.current?.focus();
  }, []);

  return (
    <select
      value={selectValue}
      className="w-[100%] h-[100%] border-[1px] border-[#000] "
      onBlur={handleTextareaBlur}
      onChange={handleTextareaChange}
    >
      <option value={""}>select</option>
      {categoryOption?.map((option, i) => (
        <option value={option.value} key={i}>
          {option.label}
        </option>
      ))}
    </select>
  );
}) ;

const handleDelete = async (
  id,
  token,
  refreshTable,
  setDeleteLoad
) => {
  setDeleteLoad(id);
  try {
    const { data } = await deleteInventoryBYid(token, id);
    if (data.status) {
      toast.success("deleted..!");
      refreshTable();
    }
  } catch (error) {
    console.log(error?.message);
    toast.error(error?.response?.data?.error || error.message);
  } finally {
    setDeleteLoad("");
  }
};
TextManufactureEditor.displayName = "TextManufactureEditor";

TextAreaEditor.displayName = "TextAreaEditor";
TextSelectEditor.displayName = "TextSelectEditor";
